export function getUniqueId() {
  return `id${window.performance.now()}`.replace(`.`, ``)
}

export function firstCap(str) {
  return str.charAt(0).toUpperCase() + str.substring(1)
}

export function isProduction() {
  /*eslint no-undef: "error"*/
  /*eslint-env node*/
  return process.env.NODE_ENV === `production`
}

export function isTesting() {
  return !isProduction()
}

export function isIos() {
  return /^(?![\w\W]*Windows Phone)[\w\W]*(iPhone|iPad|iPod)/i.test(
    navigator.userAgent
  )
}

// https://bugzilla.mozilla.org/show_bug.cgi?id=984021
export function isAdvancedCalcSupported() {
  const testBgColor = `rgba(calc(255 * 1), 255, 255, 0)`
  const expectedBgColor = `rgba(255, 255, 255, 0)`
  const body = document.body
  body.style.backgroundColor = testBgColor
  const computedBgColor = window.getComputedStyle(body).backgroundColor
  body.style.backgroundColor = ``
  if (body.getAttribute(`style`) === ``) body.removeAttribute(`style`)
  return computedBgColor === expectedBgColor
  // if the browser does not understand it, the computed value will be the default value
}

export function lostFocus(el) {
  return !document.activeElement.closest(el)
}

export function mapEventsToHandlers(eventNames, obj = {}) {
  eventNames.forEach(key => (obj[key] = this[key]))
  return obj
}

export function randomIntFromInterval(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

export function roll(diceAmount = 1, diceSides = 20, bonus = 0) {
  return randomIntFromInterval(diceAmount, diceAmount * diceSides) + bonus
}

export function rando(arr) {
  return arr[Math.floor(Math.random() * arr.length)]
}

export function slugify(text) {
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, `-`)
    .replace(/[^\w-]+/g, ``)
    .replace(/--+/g, `-`)
    .replace(/^-+/, ``)
    .replace(/-+$/, ``)
}

export function extractNameFromEmail(address) {
  if (typeof address !== `string` || address === ``) return false
  const result = address
    .split(`@`)[0]
    .split(`.`)[0]
    .split(`+`)[0]
    .trim()
  return result === address && result !== `guest` ? false : result
}

export const binder = enhancer => db => (stateNode, dbNode) =>
  enhancer(({ bindFirebaseRef }, id) => {
    return bindFirebaseRef(stateNode, db.ref(dbNode).child(id))
  })

export const compareByProp = property => (a, b) =>
  (b[property] || 0) - (a[property] || 0)

export const battle = (
  state,
  getters,
  rootState,
  { [`battles/battle`]: battle }
) => battle

export function updateProps(data) {
  data.id = data.id || this.id
  this.update(data)
}

export function createItem(creator) {
  return ({ target }) => {
    creator({ name: target.field.value })
    target.reset()
  }
}

export const getCurrentYear = () => new Date().getFullYear()

export const convertFractions = input => {
  let num
  if (`${input}`.indexOf(`/`) !== -1) {
    const bits = input.split(`/`)
    num = bits[0] / bits[1]
  } else {
    num = input * 1
  }

  return num
}
